import { render, staticRenderFns } from "./PracticeSetting.vue?vue&type=template&id=2e4d21dc"
import script from "./PracticeSetting.vue?vue&type=script&lang=js"
export * from "./PracticeSetting.vue?vue&type=script&lang=js"
import style0 from "./PracticeSetting.vue?vue&type=style&index=0&id=2e4d21dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports